import { getUsers } from "@/api/organisation";
import User from "@/models/User.model";
import { types } from "./mutations";

export default {
  /**
   * Fetches the list of all users for the current user's org
   */
  fetchOrgUsers: async ({ commit }) => {
    if (process.env.VUE_APP_ENV === "dev") {
      commit(types.SET_USERS, [
        new User({
          name: localStorage.getItem("name"),
          email: localStorage.getItem("email"),
        }),
      ]);
      return;
    } else if (state.users && state.users.length > 0) {
      return;
    } else {
      try {
        const response = await getUsers();
        commit(
          types.SET_USERS,
          response.data.data.map(user => new User(user))
        );
      } catch (error) {
        commit(types.SET_USERS, []);
      }
    }
  },

  /**
   * Resets the module state
   */
  reset: async ({ commit }) => {
    commit(types.reset);
  },
};
